(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/prescript.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/prescript.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

svs.tickets_giftshop = svs.tickets_giftshop || {};
svs.tickets_giftshop.components = svs.tickets_giftshop.components || {};
svs.tickets_giftshop.pages = svs.tickets_giftshop.pages || {};
svs.tickets_giftshop.gift = svs.tickets_giftshop.gift || {};
svs.tickets_giftshop.gift.hooks = svs.tickets_giftshop.gift.hooks || {};
svs.tickets_giftshop.gift.components = svs.tickets_giftshop.gift.components || {};
svs.tickets_giftshop.gift.giftform = svs.tickets_giftshop.gift.giftform || {};
svs.tickets_giftshop.gift.giftform.components = svs.tickets_giftshop.gift.giftform.components || {};
svs.tickets_giftshop.gift.giftform.cart = svs.tickets_giftshop.gift.giftform.cart || {};
svs.tickets_giftshop.gift.giftform.cart.components = svs.tickets_giftshop.gift.giftform.cart.components || {};
svs.tickets_giftshop.gift.giftform.cart.animations = svs.tickets_giftshop.gift.giftform.cart.animations || {};
svs.tickets_giftshop.gift.giftform.date_selector = svs.tickets_giftshop.gift.giftform.date_selector || {};
svs.tickets_giftshop.gift.giftform.date_selector.components = svs.tickets_giftshop.gift.giftform.date_selector.components || {};
svs.tickets_giftshop.products = svs.tickets_giftshop.products || {};
svs.tickets_giftshop.products.components = svs.tickets_giftshop.products.components || {};
svs.tickets_giftshop.products.animations = svs.tickets_giftshop.products.animations || {};
svs.tickets_giftshop.preview = svs.tickets_giftshop.preview || {};
svs.tickets_giftshop.preview.components = svs.tickets_giftshop.preview.components || {};
svs.tickets_giftshop.data = svs.tickets_giftshop.data || {};
svs.tickets_giftshop.data.moduleConfig = svs.tickets_giftshop.data.moduleConfig || {};
svs.tickets_giftshop.logger = svs.core.log.getLogger('tickets-giftshop');
const getThemeAndVariation = (cmsProduct, game) => {
  var _theme$skins$productV;
  let theme;
  if (cmsProduct.giftTheme && game.isThemeable) {
    theme = game.themes.find(_ref => {
      let {
        themeName
      } = _ref;
      return cmsProduct.giftTheme === themeName;
    });
  }
  if (!theme) {
    theme = {
      themeName: game.theme,
      skins: game.skins
    };
  }
  const productVariation = Math.abs((cmsProduct.productVariation - 1) % theme.skins.length);
  return {
    theme,
    productVariation,
    skinDescription: (_theme$skins$productV = theme.skins[productVariation]) === null || _theme$skins$productV === void 0 ? void 0 : _theme$skins$productV.description
  };
};
if (!svs.tickets_giftshop.data.cmsProducts) {
  let giftableGames = [];
  const {
    products = [],
    scratchGames = []
  } = svs.tickets_giftshop.data.moduleConfig;
  giftableGames = scratchGames.filter(game => game.open);
  const cmsIntersectGiftable = products.filter(product => giftableGames.some(giftableGame => giftableGame.type === product.type.split(':')[0]));
  const cmsProducts = cmsIntersectGiftable.map(product => {
    const foundGame = giftableGames.find(game => game.type === product.type.split(':')[0]);
    const {
      theme,
      productVariation,
      skinDescription
    } = getThemeAndVariation(product, foundGame);
    return {
      productDescription: product.productDescription,
      productId: foundGame.voucherId,
      productImage: theme.skins[productVariation].image,
      productName: product.productName,
      productPrice: Number(foundGame.price),
      skinDescription,
      skinId: theme.themeName,
      productVariation: productVariation + 1,
      type: product.type
    };
  });
  svs.tickets_giftshop.data.giftableGames = giftableGames.reduce((products, product) => {
    var _product$themes;
    product.isThemeable && (product === null || product === void 0 || (_product$themes = product.themes) === null || _product$themes === void 0 ? void 0 : _product$themes.forEach(_ref2 => {
      let {
        themeName,
        skins
      } = _ref2;
      for (let i = 0; i < skins.length; i++) {
        var _product$skins$i;
        products.push(_objectSpread({
          activeTheme: product.theme,
          skinDescription: (_product$skins$i = product.skins[i]) === null || _product$skins$i === void 0 ? void 0 : _product$skins$i.description,
          productId: parseInt(product.voucherId, 10),
          productVariation: i + 1,
          productPrice: product.price,
          productImage: skins[i].image,
          productName: product.name,
          skinId: themeName
        }, product));
      }
    }));

    for (let i = 0; i < product.variations; i++) {
      var _product$skins$i2;
      products.push(_objectSpread({
        activeTheme: product.theme,
        skinDescription: (_product$skins$i2 = product.skins[i]) === null || _product$skins$i2 === void 0 ? void 0 : _product$skins$i2.description,
        productId: parseInt(product.voucherId, 10),
        productVariation: i + 1,
        productPrice: product.price,
        productImage: product.skins[i].image,
        productName: product.name,
        skinId: product.theme
      }, product));
    }
    return products;
  }, []);
  svs.tickets_giftshop.data.cmsProducts = cmsProducts;
}

 })(window);